export const NAV = [
  { to: "/", label: "Início", end: true },
  { to: "/sobre", label: "Sobre" },
  { to: "/servicos", label: "Serviços" },
  { to: "/metodo", label: "Método" },
  { to: "/cases", label: "Cases" },
  { to: "/insights", label: "Insights" },
  { to: "/loja", label: "Loja" },
  { to: "/contato", label: "Contato" },
];

export const TICKER = ["Analisar", "Planejar", "Executar", "Medir", "Otimizar"];

export const OUTCOMES = [
  {
    tag: "Presença",
    title: "Mais presença nas buscas",
    desc: "Ampliar a cobertura de temas e páginas que representam demanda relevante.",
  },
  {
    tag: "Qualidade",
    title: "Mais tráfego qualificado",
    desc: "Atrair pessoas com intenção compatível com a oferta e com o estágio da jornada.",
  },
  {
    tag: "Negócio",
    title: "Mais oportunidades comerciais",
    desc: "Conectar descoberta, experiência e ação sem prometer resultado garantido.",
  },
];

export const DIFFERENTIALS = [
  "Decisões baseadas em dados",
  "Execução técnica priorizada",
  "Estratégia adaptada ao cenário",
  "Acompanhamento contínuo",
  "Comunicação transparente",
  "Foco em indicadores de negócio",
];

export const CHALLENGES = [
  { label: "Meu site não aparece no Google", to: "/servicos/estrategia-seo" },
  { label: "Tenho tráfego, mas poucas conversões", to: "/servicos/seo-on-page" },
  { label: "Meu site apresenta problemas técnicos", to: "/servicos/seo-tecnico" },
  { label: "Quero crescer em buscas locais", to: "/servicos/seo-local" },
  { label: "Preciso de uma estratégia de conteúdo", to: "/servicos/autoridade-digital" },
  { label: "Não consigo acompanhar os resultados", to: "/servicos/analytics-performance" },
];

export const CASE_CRITERIA = [
  { title: "Autorização", desc: "Cliente e informações liberados para publicação." },
  { title: "Período", desc: "Linha de base e janela de análise informadas." },
  { title: "Métrica", desc: "Fonte e definição verificadas antes de comunicar." },
  { title: "Contexto", desc: "Limites, mudanças externas e correlação explicados." },
];

export const FAQ = [
  {
    q: "O que é uma estratégia de SEO?",
    a: "É um plano que conecta oportunidades de busca, técnica, conteúdo, arquitetura e mensuração aos objetivos do negócio. A estratégia define prioridades e critérios antes da execução.",
  },
  {
    q: "Quanto tempo o SEO leva para gerar resultados?",
    a: "Não existe um prazo universal. O ritmo depende do ponto de partida, concorrência, capacidade de implementação, histórico do domínio e tipo de oportunidade. O acompanhamento deve considerar sinais iniciais e evolução de médio prazo.",
  },
  {
    q: "A EXEKUTA atende empresas de quais segmentos?",
    a: "A área de atendimento e os segmentos oficiais precisam ser confirmados comercialmente. O diagnóstico inicial verifica aderência antes de qualquer proposta.",
  },
  {
    q: "Como funciona o diagnóstico inicial?",
    a: "A empresa apresenta contexto, site, desafio e objetivo. A EXEKUTA organiza as informações necessárias para avaliar o cenário e indicar o próximo passo adequado.",
  },
  {
    q: "SEO substitui mídia paga?",
    a: "Não necessariamente. Os canais têm funções e ritmos diferentes. A combinação deve ser decidida conforme objetivo, margem, demanda, prazo e capacidade de mensuração.",
  },
  {
    q: "Como os resultados são acompanhados?",
    a: "Por indicadores definidos conforme o objetivo: visibilidade, páginas estratégicas, saúde técnica, comportamento, conversões e andamento do roadmap.",
  },
  {
    q: "É possível contratar apenas uma auditoria técnica?",
    a: "A estrutura prevê projetos de diagnóstico ou auditoria independente, desde que o escopo, acessos e critérios de entrega sejam confirmados.",
  },
];

export const PILLARS = [
  {
    num: "01",
    title: "Estratégia",
    desc: "Análise profunda. Planejamento inteligente. Decisões que geram valor.",
  },
  {
    num: "02",
    title: "Execução",
    desc: "Implementação técnica. Processos ágeis. Foco em performance.",
  },
  {
    num: "03",
    title: "Resultados",
    desc: "Crescimento orgânico. Métricas reais. Performance contínua.",
  },
];

export const INSTAGRAM = "https://www.instagram.com/exekuta.agencia/";
